var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_vm._v("版权信息：武汉工商学院")])
}
var staticRenderFns = []

export { render, staticRenderFns }